/* unplugin-vue-components disabled */import { render } from "./DcLoadingDots.vue?vue&type=template&id=50bf9155"
const script = {}

import "./DcLoadingDots.vue?vue&type=style&index=0&id=50bf9155&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__